module.exports = __webpack_public_path__ + "static/media/route-highway.f02dc86e.svg";